import { useNavigate } from "react-router-dom";

export default function PopupModal({ item, onClose }) {
    const navigate = useNavigate();
    if (!item) return null;

    const isInternal = item.link && item.link.startsWith('/');

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg p-6 max-w-lg w-full shadow-lg overflow-y-auto max-h-[80vh]"
                onClick={(e) => e.stopPropagation()}
            >
                <p className="text-gray-800 mb-4">{item.date}</p>
                <h2 className="text-xl font-bold mb-4">{item.title}</h2>
                <p className="text-gray-800 mb-4">{item.content || "本文がありません"}</p>
                {item.link && (
                    isInternal ? (
                        <button
                            onClick={() => { onClose(); navigate(item.link); }}
                            className="inline-block mt-2 px-5 py-2 bg-[#b5435f] text-white rounded-full font-semibold text-sm hover:bg-[#a2364f] transition"
                        >
                            {item.linkText || "→"}
                        </button>
                    ) : (
                        <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block mt-2 px-5 py-2 bg-[#b5435f] text-white rounded-full font-semibold text-sm hover:bg-[#a2364f] transition"
                        >
                            {item.linkText || "→"}
                        </a>
                    )
                )}
            </div>
        </div>
    );
}
